import { useContext } from 'react';
import type { Context } from 'react';

import VendingDataContext from './VendingDataContext';
import type {
  VendingSettings,
  VendingMachines,
  VendingMachinesParams,
  VendingMachineSingle,
  MachineForm,
  MachineValidate,
  MachineSubmit,
  MachineRequest,
  MachineDelete,
  RelatedOrgs,
  AvailableOrgs,
  Models,
  Versions,
} from './VendingDataContext';

type VendingDataContextValue = {
  settings: VendingSettings;
  machines: VendingMachines;
  machinesParams: VendingMachinesParams;
  machineSingle: VendingMachineSingle;
  machineForm: MachineForm;
  machineValidate: MachineValidate;
  machineSubmit: MachineSubmit;
  machineRequest: MachineRequest;
  machineDelete: MachineDelete;
  relatedOrgs: RelatedOrgs;
  availableOrgs: AvailableOrgs;
  models: Models;
  versions: Versions;
};

const vendingDataContext = VendingDataContext as unknown as Context<VendingDataContextValue>;

const useVendingDataContext = (): VendingDataContextValue => useContext(vendingDataContext);

export const useVendingSettings = (): VendingSettings => {
  const { settings } = useVendingDataContext();
  return settings;
};

export const useVendingMachines = (): VendingMachines => {
  const { machines } = useVendingDataContext();
  return machines;
};

export const useVendingMachinesParams = (): VendingMachinesParams => {
  const { machinesParams } = useVendingDataContext();
  return machinesParams;
};

export const useVendingMachineSingle = (): VendingMachineSingle => {
  const { machineSingle } = useVendingDataContext();
  return machineSingle;
};

export const useMachineForm = (): MachineForm => {
  const { machineForm } = useVendingDataContext();
  return machineForm;
};

export const useMachineValidate = (): MachineValidate => {
  const { machineValidate } = useVendingDataContext();
  return machineValidate;
};

export const useMachineSubmit = (): MachineSubmit => {
  const { machineSubmit } = useVendingDataContext();
  return machineSubmit;
};

export const useMachineRequest = (): MachineRequest => {
  const { machineRequest } = useVendingDataContext();
  return machineRequest;
};

export const useMachineDelete = (): MachineDelete => {
  const { machineDelete } = useVendingDataContext();
  return machineDelete;
};

export const useRelatedOrgs = (): RelatedOrgs => {
  const { relatedOrgs } = useVendingDataContext();
  return relatedOrgs;
};

export const useAvailableOrgs = (): AvailableOrgs => {
  const { availableOrgs } = useVendingDataContext();
  return availableOrgs;
};

export const useModels = (): Models => {
  const { models } = useVendingDataContext();
  return models;
};

export const useVersions = (): Versions => {
  const { versions } = useVendingDataContext();
  return versions;
};
